core-checkbox {
  display: flex;
}

.core-checkbox {
  display: flex;
  align-items: flex-start;
  gap: var(--number-spacing-2xsmall);
}

.core-checkbox .checkbox-wrapper {
  display: flex;
  padding: var(--number-spacing-5xsmall);
  justify-content: center;
  align-items: center;
}

.core-checkbox.checkbox--disabled .checkbox-box {
  cursor: not-allowed;
}

.core-checkbox .checkbox-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  height: 1.25rem;
  box-sizing: border-box;
  border: 1px solid var(--color-selection-primary-border-default);
  border-radius: var(--number-radius-2xsmall);
  background-color: var(--color-selection-primary-background-default);
  cursor: pointer;
  transition: background-color var(--motion-duration-fast) var(--motion-easing-move),
    border var(--motion-duration-fast) var(--motion-easing-move);
}

.core-checkbox.checkbox--checked:not(.checkbox--disabled) .checkbox-box, .core-checkbox.checkbox--indeterminate:not(.checkbox--disabled) .checkbox-box {
  background-color: var(--color-selection-primary-background-selected);
  border-color: var(--color-selection-primary-border-selected);
}

.core-checkbox:not(.checkbox--disabled) .checkbox-box:hover,
.core-checkbox:not(.checkbox--disabled) .checkbox-box:focus-visible {
  border: 1px solid var(--color-selection-primary-border-interacting);
  background-color: var(--color-selection-primary-background-interacting);
}

.core-checkbox.checkbox--disabled .checkbox-box {
  border-color: transparent;
  border-radius: var(--number-radius-2xsmall);
  background: var(--color-global-all-disabled-soft);
}

.core-checkbox .checkbox-box:focus-visible {
  outline: 2px solid var(--color-global-border-focus);
  outline-offset: 2px;
}

.core-checkbox .checkbox-box svg {
  fill: var(--color-selection-primary-content-selected);
  animation: appear var(--motion-duration-medium) var(--motion-easing-enter);
  transition: fill var(--motion-duration-fast) var(--motion-easing-move);
}

.core-checkbox.checkbox--disabled .checkbox-box svg {
  fill: var(--color-global-all-disabled-strong);
}

.core-checkbox:not(.checkbox--disabled) .checkbox-box:hover svg,
.core-checkbox:not(.checkbox--disabled) .checkbox-box:focus-visible svg {
  fill: var(--color-selection-primary-content-interacting);
}

.core-checkbox .infos-box {
  display: flex;
  flex-direction: column;
}

.core-checkbox .checkbox-label, .checkbox-description {
  color: var(--color-neutral-content-medium);
}

@keyframes appear {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
